<template>
<!-- tabindex="-1" so it is focusable so the popup does not get closed if the user click on an empty space of the
sidebar. https://stackoverflow.com/a/38317768/10406353 -->
<SidebarBase
  @focusout.native="onFocusout"
  @focusin.native="onFocusin"
  tabindex="-1"
  class="sidebar-with-popup"
>
  <template #categories="{ visibleCategoriesTree }">
    <ul>
      <li
        v-for="c of visibleCategoriesTree"
        :key="c.id"
      >
        <CategoryBase
          @click:expand="onExpandClick(c)"
          :category="c"
          :children-expanded="expandedCategory === c"
          component="button"
          aria-haspopup="tree"
          :aria-controls="expandedCategory === c ? popupId : undefined"
          :aria-owns="expandedCategory === c ? popupId : undefined"
          class="sidebar-with-popup__base-category"
        />
      </li>
    </ul>
  </template>
  <template #before>
    <!-- `tabindex="-1"` so we can focus it when it gets opened. -->
    <transition name="slide-right">
      <Popup
        v-if="expandedCategory"
        :category="expandedCategory"
        :id="popupId"
        ref="popup"
        tabindex="-1"
        class="sidebar-with-popup__popup"
        @keydown.native.esc="expandedCategory = null"
        @close="expandedCategory = null"
      />
    </transition>
  </template>
</SidebarBase>
</template>

<script>
import SidebarBase from '../Base';
import CategoryBase from '../categories/Base';

export default {
  components: {
    SidebarBase,
    CategoryBase,
    Popup: () => import('../Popup'),
  },
  methods: {
    onFocusout() {
      this.closePopupTimeoutId = setTimeout(() => {
        this.expandedCategory = null;
      });
    },
    onFocusin(e) {
      clearTimeout(this.closePopupTimeoutId);
    },
    async onExpandClick(category) {
      if (this.expandedCategory === category) {
        this.expandedCategory = null;
      } else {
        this.expandedCategory = category;
        await import('../Popup');
        await this.$nextTick();
        this.$refs.popup.$el.focus();
      }
    }
  },
  computed: {
    popupId() {
      return `sidebar-${Math.random()}-popup-${this.expandedCategory?.slug}`;
    },
  },
  watch: {
    '$route'() {
      this.expandedCategory = null;
    },
  },
  data() {
    return {
      expandedCategory: null,
      closePopupTimeoutId: -1,
    }
  },
}
</script>

<style lang="less">
.sidebar-with-popup {
  &__base-category {
    @apply w-full text-left;
  }
  &__popup {
    @apply absolute top-0 bottom-0;
    left: 100%;
    &:focus {
      @apply outline-none;
    }
  }
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.18s;
}
.slide-right-enter-active {
  transition-timing-function: ease-out;
}
.slide-right-leave-active {
  transition-timing-function: ease-in;
}
.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(-100%);
}
</style>
